/* eslint-disable react/prop-types */
import {
  FaEye,
  FaPaperPlane,
  FaPencil,
  FaTrash,
  FaUserPlus,
} from "react-icons/fa6";
import { Link } from "react-router-dom";

function AddButton({ to, name }) {
  return (
    <Link to={to} className=" p-2 px-3 bg-color6 text-color5 rounded-md">
      {name}
    </Link>
  );
}

function SaveButton({ name, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className=" w-full p-2 px-3 bg-color7 text-color5 rounded-md"
    >
      {name}
    </button>
  );
}

function CancelButton({ name, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className=" w-full p-2 px-3 bg-color8 text-color5 rounded-md"
    >
      {name}
    </button>
  );
}

function ViewButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} className=" text-color5 rounded-md">
      <FaEye title="View details" />
    </button>
  );
}

function EditButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} className=" text-color5 rounded-md">
      <FaPencil title="Edit" />
    </button>
  );
}

function DeleteButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} className=" text-color5 rounded-md">
      <FaTrash title="Delete" />
    </button>
  );
}

function SendButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} className=" text-color5 rounded-md">
      <FaPaperPlane title="Send" />
    </button>
  );
}

function AddUserButton({ onClick }) {
  return (
    <button type="button" onClick={onClick} className=" text-color5 rounded-md">
      <FaUserPlus title="Add Customer" />
    </button>
  );
}

function ButtonType({ children, onClick, className }) {
  return (
    <div
      onClick={onClick}
      className={`bg-cgreen/50 text-cwhite text-sm h-[38px] px-4 flex flex-shrink-0 justify-center items-center rounded-md cursor-pointer ${className}`}
    >
      <span className="flex-shrink-0">{children}</span>
    </div>
  );
}

export {
  AddButton,
  SaveButton,
  CancelButton,
  ViewButton,
  EditButton,
  DeleteButton,
  SendButton,
  AddUserButton,
  ButtonType,
};
